import { useAscContext } from '@neo.tax/asc/context';
import { isAscPathAvailable, AscPath } from '@neo.tax/asc/utils';
import {
  Loader,
  NavigateTo,
  RedirectState,
  useCurrentCompanyId,
  useCurrentUserScopeForCurrentCompany,
  getDefaultAscPath,
} from '@neo.tax/shared';

export const AscPathLoader = ({
  path,
  children,
  useRedirect = (): RedirectState => ({ isLoading: false }),
}: {
  path: AscPath;
  children: React.ReactNode;
  useRedirect: () => RedirectState;
}): React.ReactElement => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId, periodName } = useAscContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  if (
    !isAscPathAvailable({
      isNonFinancialUser: limitAccessToFinancialData,
      path,
    })
  ) {
    return <NavigateTo to={getDefaultAscPath({ companyId, fiscalYearId, periodName })} />;
  }

  return <Loader useRedirect={useRedirect}>{children}</Loader>;
};
